/* eslint-disable import/no-extraneous-dependencies */
import Color from 'color';
import {ColorSchemeType, HSL} from 'epic-diesel-common/src/models/cms/Theme';

export const stripHash = (hex: string): string => {
    if (hex.charAt(0) !== '#') return hex;
    return hex.substring(1);
};

export const isValidHex = (hex: string): boolean => {
    const isEmpty = hex === '#' || hex === '';
    if (isEmpty) return false;
    const digitCount: number = stripHash(hex).length;
    return digitCount === 3 || digitCount === 6;
};

export const isValidHSL = (hsl: HSL): boolean => {
    return typeof hsl.h === 'number' && typeof hsl.s === 'number' && typeof hsl.l === 'number';
};

export const isValidRGBString = (rgb: string): boolean => {
    const matchRegex = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/;
    return matchRegex.test(rgb);
};

export const isValidRGBAString = (rgba: string): boolean => {
    const matchRegex = /rgba\((\d{1,3}), (\d{1,3}), (\d{1,3}), (0\.[0-9]+|[0-1])\)/;
    return matchRegex.test(rgba);
};

export const prependHash = (hex: string): string => {
    if (!hex || hex.charAt(0) === '#') return hex;
    return `#${hex}`;
};

export const HexToHSL = (hex: string) => {
    const color = Color(prependHash(hex));
    return color.hsl().object();
};

export const HSLToHex = (hsl: Record<string, number>) => {
    const color = Color(hsl);
    return color.hex();
};

export const HSLToRGB = (hsl: Record<string, number>) => {
    const color = Color(hsl);
    return color.rgb();
};

export const HSLToRGBString = (hsl: Record<string, number>): string => HSLToRGB(hsl).string();

export const HSLAToRGBA = (hsla: Record<string, number>) => {
    const {h, s, l, a} = hsla;
    const color = Color({h, s, l});
    return color.alpha(a).rgb();
};

export const HSLAToRGBAString = (hsl: Record<string, number>): string => HSLAToRGBA(hsl).string();

export const convertHSL = (hslProps: Record<string, number>): Record<string, string> => {
    const color = new Color(hslProps);
    return {
        hex: color.hex(),
        rgb: color
            .rgb()
            .array()
            .map(Math.round)
            .join(' ')
    };
};

export const deriveSchemeFromBackground = (background: string | undefined): ColorSchemeType => {
    if (!background) return ColorSchemeType.dark;
    const backgroundColor = Color(background);
    return backgroundColor.isDark() ? ColorSchemeType.dark : ColorSchemeType.light;
};
